import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { itemPreview } from 'page/catalog/store/ItemPreviewStore'
import { getTranslation } from 'util/translations'

export const ItemDetails = observer(() => {
  const demo = useDemo()
  const { stand, basic } = demo
  const { articles, categories, colors, seasons, brands } = demo.product.details ?? {}
  const { item } = itemPreview.it
  const font = basic ? 16 : stand ? 20 : 13
  const {
    article,
    brand_name,
    dress_category,
    dress_colors,
    season,
  } = item

  return (
    <Vertical gap={8}>
      {articles && article && (
        <Space gap={[2, 6]} wrap>
          <Typo size={font} upper secondary>
            {i18n('Article')}
          </Typo>
          <Space gap={4} top>
            <Space>
              <Icon size={16} name="barcode" />
            </Space>
            <Typo size={font} line={16} wrap upper>
              {article}
            </Typo>
          </Space>
        </Space>
      )}
      {brands && brand_name && (
        <Space gap={[2, 6]} wrap>
          <Typo size={font} upper secondary>
            {i18n('demo.Brand')}
          </Typo>
          <Typo size={font} upper wrap>
            {brand_name}
          </Typo>
        </Space>
      )}
      {categories && dress_category && (
        <Space gap={[2, 6]} wrap>
          <Typo size={font} upper secondary>
            {i18n('demo.Category')}
          </Typo>
          <Typo size={font} upper wrap>
            {getTranslation('categories', dress_category)}
          </Typo>
        </Space>
      )}
      {colors && dress_colors && (
        <Space gap={[2, 6]} wrap>
          <Typo size={font} upper secondary>
            {i18n('demo.Color')}
          </Typo>
          <Typo size={font} upper wrap>
            {getTranslation('colors', dress_colors)}
          </Typo>
        </Space>
      )}
      {seasons && season && (
        <Space gap={[2, 6]} wrap>
          <Typo size={font} upper secondary>
            {i18n('demo.Season')}
          </Typo>
          <Typo size={font} upper wrap>
            {season}
          </Typo>
        </Space>
      )}
    </Vertical>
  )
})
